module.exports = __webpack_public_path__ + "img/Progress-Report-Inspect-Small.faad3ee9.png";